import Vue from 'vue'
import Vuex from 'vuex'
import { some } from 'lodash'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  siteRoot: window.pageData.siteRoot,
  facebookAppId: window.pageData.checkoutDownload.facebookAppId,
  playerId: window.pageData.checkoutDownload.playerId,
  viewModel: window.pageData.checkoutDownload.viewModel
}

const mutations = {
}

const getters = {
  hasMotionProducts: (state) => {
    return state.viewModel.MotionVideoReady
  },
  hasVideoClips: (state) => {
    return state.viewModel.VideoClips !== null && state.viewModel.VideoClips.length > 0
  },
  hasFacebookPhoto: (state) => {
    return state.viewModel.FacebookImageDownloadEntitled && some(state.viewModel.Product.Parts, p => p.HaveFull === true)
  },
  hasGradReelPackage: (state) => {
    return state.viewModel.HasGradReelPackage
  },
  somePartsCurrentlyRetouching: (state) => {
    return some(state.viewModel.Product.Parts, (p) => {
      return p.IsCurrentlyRetouching === true
    })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/grad-images/checkout-download/store.js